var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{ref:"autocomplete",attrs:{"items":_vm.items,"get-label":_vm.getAssignationLabel,"component-item":_vm.assignationItem,"min-len":1,"auto-select-one-item":false,"input-attrs":{
    placeholder: this.$t('people.select_person'),
    class: _vm.big ? 'big v-autocomplete-input' : 'v-autocomplete-input'
  }},on:{"update-items":_vm.update,"input":_vm.onChange},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})}
var staticRenderFns = []

export { render, staticRenderFns }